import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.97243 5.46544L5.3365 0.153138C5.29459 0.105068 5.24279 0.0665168 5.18459 0.0400955C5.12639 0.0136741 5.06316 0 4.99918 0C4.9352 0 4.87197 0.0136741 4.81377 0.0400955C4.75557 0.0665168 4.70376 0.105068 4.66185 0.153138L0.0273217 5.46544C0.013317 5.48146 0.0042364 5.50113 0.00116156 5.52213C-0.00191327 5.54313 0.00114721 5.56457 0.00997843 5.58388C0.0188096 5.6032 0.0330394 5.61959 0.0509727 5.63109C0.0689061 5.6426 0.0897872 5.64873 0.111129 5.64877H1.24252C1.30678 5.64877 1.36824 5.62099 1.41154 5.57238L4.4691 2.06835V9.88889C4.4691 9.95 4.51938 10 4.58084 10H5.41891C5.48037 10 5.53065 9.95 5.53065 9.88889V2.06835L8.58822 5.57238C8.63012 5.62099 8.69158 5.64877 8.75723 5.64877H9.88862C9.9836 5.64877 10.0353 5.53766 9.97243 5.46544Z",
		fill: "#40A9FF"
	})]
});
const ForwardRef = forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
